<template>
  <div class="side-bar-wrap" :class="{ portrait: bottom, space: groupIcons }">
    <div class="icon-wrap" v-tooltip="$t('tooltips.home')">
      <router-link to="/">
        <svg
          width="36"
          height="36"
          viewBox="0 0 36 36"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0)">
            <path
              d="M34.8577 15.8073L18.839 0.341157C18.3724 -0.113719 17.6281 -0.113719 17.1614 0.341157L1.14339 15.8067C0.907571 16.0342 0.774414 16.3479 0.774414 16.6756C0.774414 17.3427 1.31519 17.8834 1.98218 17.8834H4.11088V34.7922C4.11088 35.4593 4.65158 36 5.31865 36H13.773C14.4401 36 14.9808 35.4593 14.9808 34.7922V25.13H21.0197V34.7922C21.0197 35.4593 21.5604 36 22.2274 36H30.6818C31.3489 36 31.8896 35.4593 31.8896 34.7922V17.8834H34.0183C34.3457 17.8834 34.6591 17.7505 34.8867 17.515C35.3502 17.0354 35.3372 16.2708 34.8577 15.8073ZM31.8896 16.6756C31.2225 16.6756 30.6818 17.2164 30.6818 17.8834V34.7922H22.2274V25.13C22.2274 24.463 21.6867 23.9223 21.0197 23.9223H14.9808C14.3137 23.9223 13.773 24.463 13.773 25.13V34.7922H5.31865V17.8834C5.31865 17.2164 4.77795 16.6756 4.11088 16.6756H1.98218L18.0002 1.21015L34.0243 16.6756H31.8896Z"
              fill="#888C8E"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="36" height="36" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </router-link>
    </div>
    <div
      class="icon-wrap"
      v-tooltip="$t('tooltips.info')"
      v-if="parseInt(fairConfig.FC_INFO)"
    >
      <router-link to="/info-booth">
        <svg
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 480 480"
          style="enable-background: new 0 0 480 480; width: 32px; height: 32px"
          xml:space="preserve"
        >
          <g>
            <g>
              <path
                d="M240,0C107.452,0,0,107.452,0,240s107.452,240,240,240s240-107.452,240-240C479.85,107.514,372.486,0.15,240,0z M240,464C116.288,464,16,363.712,16,240S116.288,16,240,16s224,100.288,224,224C463.859,363.653,363.653,463.859,240,464z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M440,232c-4.418,0-8,3.582-8,8c-0.123,105.987-86.013,191.877-192,192c-4.418,0-8,3.582-8,8s3.582,8,8,8c114.822-0.128,207.872-93.178,208-208C448,235.582,444.418,232,440,232z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M240,32C125.178,32.128,32.128,125.178,32,240c0,4.418,3.582,8,8,8s8-3.582,8-8c0.123-105.987,86.013-191.877,192-192c4.418,0,8-3.582,8-8S244.418,32,240,32z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M240,120c-13.255,0-24,10.745-24,24s10.745,24,24,24s24-10.745,24-24S253.255,120,240,120z M240,152c-4.418,0-8-3.582-8-8s3.582-8,8-8s8,3.582,8,8S244.418,152,240,152z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M280,320h-16V184h-80v24c0,8.837,7.163,16,16,16h16v136h80v-24C296,327.163,288.837,320,280,320z M280,344h-48V208h-32v-8h48v136h32V344z"
              />
            </g>
          </g>
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
        </svg>
      </router-link>
    </div>
    <div
      class="icon-wrap"
      v-tooltip="$t('tooltips.floor')"
      v-if="floors.length > 0 && checkPermissions(['expo_view'])"
    >
      <div
        @click="toggleFloor"
        @mouseenter="openFloor"
        @mouseleave="closeFloor"
      >
        <a href="#">
          <svg
            width="34"
            height="34"
            viewBox="0 0 34 34"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0)">
              <path
                d="M31.3203 20.6893H30.7502V11.7354C31.5214 11.2888 32.0418 10.455 32.0418 9.50152V2.60455C32.0418 1.1684 30.8734 0 29.4373 0H4.5626C3.12645 0 1.95805 1.1684 1.95805 2.60455V9.50152C1.95805 10.4551 2.47845 11.2889 3.24969 11.7355V20.6894H2.67951C1.95617 20.6894 1.36768 21.2779 1.36768 22.0012V22.837C1.36768 23.5604 1.95617 24.1489 2.67951 24.1489H2.71178V32.1584C2.71178 33.1739 3.5379 34.0001 4.55341 34.0001H29.4464C30.4619 34.0001 31.288 33.1739 31.288 32.1584V24.1488H31.3203C32.0436 24.1488 32.6321 23.5603 32.6321 22.837V22.0011C32.6322 21.2778 32.0437 20.6893 31.3203 20.6893ZM29.7438 20.6893H28.5732V11.9239C28.8504 12.0259 29.1496 12.0817 29.4617 12.0817C29.5571 12.0817 29.6511 12.0761 29.7438 12.0659V20.6893ZM29.4617 11.0753C28.5939 11.0753 27.8879 10.3694 27.8879 9.50152V9.14877H31.0355V9.50152C31.0355 10.3693 30.3295 11.0753 29.4617 11.0753ZM7.11831 9.14877H10.26L10.2593 9.49656C10.2592 9.53386 10.2604 9.57082 10.2619 9.60779C10.207 10.4262 9.52415 11.0753 8.69206 11.0753C7.82428 11.0753 7.11825 10.3694 7.11825 9.50152V9.14877H7.11831ZM11.2723 9.50152V9.14877H14.4139L14.4132 9.50447C14.4116 10.3723 13.7043 11.0769 12.8364 11.0753C12.0051 11.0737 11.3239 10.4242 11.2696 9.60672C11.271 9.57176 11.2723 9.53681 11.2723 9.50152ZM15.4261 9.14877H18.5738V9.50152C18.5738 10.3694 17.8678 11.0753 17 11.0753C16.1321 11.0753 15.4261 10.3694 15.4261 9.50152V9.14877ZM19.5801 9.14877H22.7276V9.50152C22.7276 10.3694 22.0217 11.0753 21.1538 11.0753C20.2861 11.0753 19.5801 10.3694 19.5801 9.50152V9.14877ZM23.734 9.14877H26.8816V9.50152C26.8816 10.3694 26.1756 11.0753 25.3078 11.0753C24.4399 11.0753 23.734 10.3694 23.734 9.50152V9.14877ZM31.0355 2.60455V8.14246H27.8879V1.00632H29.4373C30.3186 1.00632 31.0355 1.72329 31.0355 2.60455ZM26.8816 8.14246H23.734V1.00632H26.8816V8.14246ZM22.7276 8.14246H19.5801V1.00632H22.7276V8.14246ZM18.5738 8.14246H15.4261L15.4357 1.00632H18.5738V8.14246ZM14.4198 1.00934L14.4158 8.14246H11.2722L11.2818 1.00337L14.4198 1.00934ZM10.2619 8.14246H7.11831V1.00632H10.2659L10.2619 8.14246ZM4.5626 1.00632H6.112V8.14246H2.96437V2.60455C2.96437 1.72329 3.68134 1.00632 4.5626 1.00632ZM2.96437 9.14877H6.112V9.50152C6.112 10.3694 5.40603 11.0753 4.53818 11.0753C3.67033 11.0753 2.96437 10.3694 2.96437 9.50152V9.14877ZM4.25608 12.0659C4.34879 12.076 4.44285 12.0816 4.53825 12.0816C4.85034 12.0816 5.14955 12.0258 5.42669 11.9239V20.6892H4.25608V12.0659ZM30.2817 32.1584C30.2817 32.6189 29.907 32.9937 29.4464 32.9937H4.55348C4.09292 32.9937 3.71817 32.6189 3.71817 32.1584V24.1488H30.2817V32.1584ZM31.6259 22.837C31.6259 23.0054 31.4888 23.1425 31.3203 23.1425H30.7849H3.21501H2.67958C2.51112 23.1425 2.37406 23.0054 2.37406 22.837V22.0011C2.37406 21.8327 2.51112 21.6956 2.67958 21.6956H12.5809C12.8588 21.6956 13.084 21.4703 13.084 21.1925C13.084 20.9146 12.8588 20.6893 12.5809 20.6893H6.43294V11.2504C6.49762 11.1805 6.55847 11.1069 6.61516 11.0301C7.08537 11.6674 7.84119 12.0817 8.69213 12.0817C9.54099 12.0817 10.2953 11.6694 10.7657 11.0348C11.2352 11.6681 11.9874 12.08 12.8345 12.0817C13.6893 12.0833 14.4487 11.6666 14.9197 11.0254C15.3897 11.6653 16.147 12.0817 17 12.0817C17.851 12.0817 18.6067 11.6674 19.077 11.0301C19.5472 11.6674 20.303 12.0817 21.1539 12.0817C22.0048 12.0817 22.7606 11.6673 23.2309 11.0301C23.7011 11.6674 24.4569 12.0817 25.3078 12.0817C26.1588 12.0817 26.9145 11.6674 27.3848 11.0301C27.4415 11.1069 27.5024 11.1804 27.567 11.2504V20.6893H14.5935C14.3156 20.6893 14.0904 20.9146 14.0904 21.1925C14.0904 21.4703 14.3156 21.6956 14.5935 21.6956H31.3204C31.4889 21.6956 31.6259 21.8327 31.6259 22.0011V22.837H31.6259Z"
                fill="#888C8E"
              />
              <path
                d="M9.91306 30.869H13.772C14.0499 30.869 14.2752 30.6438 14.2752 30.3659C14.2752 30.088 14.0499 29.8627 13.772 29.8627H9.91306C9.88509 29.8627 9.86228 29.8399 9.86228 29.8119V27.1794C9.86228 27.1514 9.88502 27.1286 9.91306 27.1286H24.5321C24.5602 27.1286 24.583 27.1514 24.583 27.1794V29.8119C24.583 29.84 24.5602 29.8627 24.5321 29.8627H15.7847C15.5068 29.8627 15.2816 30.088 15.2816 30.3659C15.2816 30.6438 15.5068 30.869 15.7847 30.869H24.5321C25.115 30.869 25.5893 30.3948 25.5893 29.8119V27.1794C25.5893 26.5965 25.115 26.1223 24.5321 26.1223H9.91306C9.33013 26.1223 8.85596 26.5966 8.85596 27.1794V29.8119C8.85596 30.3949 9.33013 30.869 9.91306 30.869Z"
                fill="#888C8E"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect width="34" height="34" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </a>
        <transition name="chat-fade">
          <div
            class="conf-drawer"
            :class="{ portrait: bottom }"
            v-if="openFloors"
            @mouseenter="cancelCloseFloor"
            @mouseleave="closeFloor"
          >
            <div class="triangle-arrow"></div>
            <div class="conf-wrapper">
              <div
                class="single-conf-item"
                v-for="(item, i) in floors"
                :key="i"
                @click="navigateTo('/floor/' + item.loc_id)"
              >
                <svg
                  width="34"
                  height="34"
                  viewBox="0 0 34 34"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0)">
                    <path
                      d="M31.3203 20.6893H30.7502V11.7354C31.5214 11.2888 32.0418 10.455 32.0418 9.50152V2.60455C32.0418 1.1684 30.8734 0 29.4373 0H4.5626C3.12645 0 1.95805 1.1684 1.95805 2.60455V9.50152C1.95805 10.4551 2.47845 11.2889 3.24969 11.7355V20.6894H2.67951C1.95617 20.6894 1.36768 21.2779 1.36768 22.0012V22.837C1.36768 23.5604 1.95617 24.1489 2.67951 24.1489H2.71178V32.1584C2.71178 33.1739 3.5379 34.0001 4.55341 34.0001H29.4464C30.4619 34.0001 31.288 33.1739 31.288 32.1584V24.1488H31.3203C32.0436 24.1488 32.6321 23.5603 32.6321 22.837V22.0011C32.6322 21.2778 32.0437 20.6893 31.3203 20.6893ZM29.7438 20.6893H28.5732V11.9239C28.8504 12.0259 29.1496 12.0817 29.4617 12.0817C29.5571 12.0817 29.6511 12.0761 29.7438 12.0659V20.6893ZM29.4617 11.0753C28.5939 11.0753 27.8879 10.3694 27.8879 9.50152V9.14877H31.0355V9.50152C31.0355 10.3693 30.3295 11.0753 29.4617 11.0753ZM7.11831 9.14877H10.26L10.2593 9.49656C10.2592 9.53386 10.2604 9.57082 10.2619 9.60779C10.207 10.4262 9.52415 11.0753 8.69206 11.0753C7.82428 11.0753 7.11825 10.3694 7.11825 9.50152V9.14877H7.11831ZM11.2723 9.50152V9.14877H14.4139L14.4132 9.50447C14.4116 10.3723 13.7043 11.0769 12.8364 11.0753C12.0051 11.0737 11.3239 10.4242 11.2696 9.60672C11.271 9.57176 11.2723 9.53681 11.2723 9.50152ZM15.4261 9.14877H18.5738V9.50152C18.5738 10.3694 17.8678 11.0753 17 11.0753C16.1321 11.0753 15.4261 10.3694 15.4261 9.50152V9.14877ZM19.5801 9.14877H22.7276V9.50152C22.7276 10.3694 22.0217 11.0753 21.1538 11.0753C20.2861 11.0753 19.5801 10.3694 19.5801 9.50152V9.14877ZM23.734 9.14877H26.8816V9.50152C26.8816 10.3694 26.1756 11.0753 25.3078 11.0753C24.4399 11.0753 23.734 10.3694 23.734 9.50152V9.14877ZM31.0355 2.60455V8.14246H27.8879V1.00632H29.4373C30.3186 1.00632 31.0355 1.72329 31.0355 2.60455ZM26.8816 8.14246H23.734V1.00632H26.8816V8.14246ZM22.7276 8.14246H19.5801V1.00632H22.7276V8.14246ZM18.5738 8.14246H15.4261L15.4357 1.00632H18.5738V8.14246ZM14.4198 1.00934L14.4158 8.14246H11.2722L11.2818 1.00337L14.4198 1.00934ZM10.2619 8.14246H7.11831V1.00632H10.2659L10.2619 8.14246ZM4.5626 1.00632H6.112V8.14246H2.96437V2.60455C2.96437 1.72329 3.68134 1.00632 4.5626 1.00632ZM2.96437 9.14877H6.112V9.50152C6.112 10.3694 5.40603 11.0753 4.53818 11.0753C3.67033 11.0753 2.96437 10.3694 2.96437 9.50152V9.14877ZM4.25608 12.0659C4.34879 12.076 4.44285 12.0816 4.53825 12.0816C4.85034 12.0816 5.14955 12.0258 5.42669 11.9239V20.6892H4.25608V12.0659ZM30.2817 32.1584C30.2817 32.6189 29.907 32.9937 29.4464 32.9937H4.55348C4.09292 32.9937 3.71817 32.6189 3.71817 32.1584V24.1488H30.2817V32.1584ZM31.6259 22.837C31.6259 23.0054 31.4888 23.1425 31.3203 23.1425H30.7849H3.21501H2.67958C2.51112 23.1425 2.37406 23.0054 2.37406 22.837V22.0011C2.37406 21.8327 2.51112 21.6956 2.67958 21.6956H12.5809C12.8588 21.6956 13.084 21.4703 13.084 21.1925C13.084 20.9146 12.8588 20.6893 12.5809 20.6893H6.43294V11.2504C6.49762 11.1805 6.55847 11.1069 6.61516 11.0301C7.08537 11.6674 7.84119 12.0817 8.69213 12.0817C9.54099 12.0817 10.2953 11.6694 10.7657 11.0348C11.2352 11.6681 11.9874 12.08 12.8345 12.0817C13.6893 12.0833 14.4487 11.6666 14.9197 11.0254C15.3897 11.6653 16.147 12.0817 17 12.0817C17.851 12.0817 18.6067 11.6674 19.077 11.0301C19.5472 11.6674 20.303 12.0817 21.1539 12.0817C22.0048 12.0817 22.7606 11.6673 23.2309 11.0301C23.7011 11.6674 24.4569 12.0817 25.3078 12.0817C26.1588 12.0817 26.9145 11.6674 27.3848 11.0301C27.4415 11.1069 27.5024 11.1804 27.567 11.2504V20.6893H14.5935C14.3156 20.6893 14.0904 20.9146 14.0904 21.1925C14.0904 21.4703 14.3156 21.6956 14.5935 21.6956H31.3204C31.4889 21.6956 31.6259 21.8327 31.6259 22.0011V22.837H31.6259Z"
                      fill="#888C8E"
                    />
                    <path
                      d="M9.91306 30.869H13.772C14.0499 30.869 14.2752 30.6438 14.2752 30.3659C14.2752 30.088 14.0499 29.8627 13.772 29.8627H9.91306C9.88509 29.8627 9.86228 29.8399 9.86228 29.8119V27.1794C9.86228 27.1514 9.88502 27.1286 9.91306 27.1286H24.5321C24.5602 27.1286 24.583 27.1514 24.583 27.1794V29.8119C24.583 29.84 24.5602 29.8627 24.5321 29.8627H15.7847C15.5068 29.8627 15.2816 30.088 15.2816 30.3659C15.2816 30.6438 15.5068 30.869 15.7847 30.869H24.5321C25.115 30.869 25.5893 30.3948 25.5893 29.8119V27.1794C25.5893 26.5965 25.115 26.1223 24.5321 26.1223H9.91306C9.33013 26.1223 8.85596 26.5966 8.85596 27.1794V29.8119C8.85596 30.3949 9.33013 30.869 9.91306 30.869Z"
                      fill="#888C8E"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0">
                      <rect width="34" height="34" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <span>{{ item.name }}</span>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <div
      class="icon-wrap"
      v-tooltip="$t('tooltips.conference')"
      v-if="conferences.length > 0 && checkPermissions(['conf_view'])"
    >
      <div @click="toggleConf" @mouseenter="openConf" @mouseleave="closeConf">
        <a href="#">
          <svg
            width="31"
            height="31"
            viewBox="0 0 31 31"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0)">
              <path
                d="M30.4836 1.35267e-08C30.4835 1.35267e-08 30.4834 1.35267e-08 30.4833 1.35267e-08H0.516667C0.231402 -6.45698e-05 6.45833e-05 0.231144 0 0.516408C0 0.516473 0 0.516602 0 0.516667V10.85H1.03333V1.03333H29.9667V12.4H11.8833V13.4333H30.4833C30.7686 13.4334 30.9999 13.2022 31 12.9169C31 12.9169 31 12.9167 31 12.9167V0.516667C31.0001 0.231402 30.7689 6.45969e-05 30.4836 1.35267e-08Z"
                fill="#888C8E"
              />
              <path
                d="M27.3831 2.58325H17.0498V3.61659H27.3831V2.58325Z"
                fill="#888C8E"
              />
              <path
                d="M28.9334 5.68335H18.6001V6.71668H28.9334V5.68335Z"
                fill="#888C8E"
              />
              <path
                d="M26.8665 8.78345H16.5332V9.81678H26.8665V8.78345Z"
                fill="#888C8E"
              />
              <path
                d="M16.4921 4.45455C16.1384 3.60431 15.1624 3.20183 14.3122 3.55555C14.2977 3.56163 14.2832 3.56783 14.2689 3.57428L10.0795 5.74751C10.2447 5.40509 10.3315 5.03012 10.3333 4.64998C10.3333 3.22327 9.17671 2.06665 7.75 2.06665C6.32329 2.06665 5.16667 3.22327 5.16667 4.64998C5.1686 5.21076 5.3548 5.75539 5.69657 6.19998H5.67507C4.20851 6.2098 2.89934 7.12152 2.38157 8.49373L1.00233 13.2476C0.673992 14.1005 1.09921 15.0582 1.95216 15.3865C2.34108 15.5362 2.77217 15.5337 3.15935 15.3794C3.6042 15.2002 3.95037 14.8383 4.1097 14.3859L4.65 12.6664V20.144C4.20541 19.8023 3.66078 19.6161 3.1 19.6141C1.67542 19.612 0.518798 20.7651 0.516667 22.1898C0.515633 22.8875 0.797217 23.5558 1.29729 24.0424C0.503685 24.4478 0.00310001 25.2626 1.35267e-08 26.1537V30.4833C-6.45698e-05 30.7686 0.231144 30.9999 0.516408 31C0.516473 31 0.516602 31 0.516667 31H5.68333C5.9686 31 6.19994 30.7688 6.2 30.4836C6.2 30.4835 6.2 30.4834 6.2 30.4833V26.1537C6.19748 25.4214 5.85726 24.7313 5.27801 24.2833H9.18872C8.60941 24.7313 8.26919 25.4214 8.26673 26.1537V30.4833C8.26667 30.7686 8.49787 30.9999 8.78314 31C8.7832 31 8.78333 31 8.7834 31H13.9501C14.2353 31 14.4667 30.7688 14.4667 30.4836C14.4667 30.4835 14.4667 30.4834 14.4667 30.4833V26.1537C14.4636 25.2626 13.963 24.4478 13.1694 24.0424C14.1895 23.0467 14.2094 21.4125 13.2137 20.3924C12.6005 19.7642 11.7101 19.4907 10.8501 19.6664V9.09713L15.5931 6.63437C16.4433 6.28071 16.8458 5.30473 16.4921 4.45455ZM7.75 3.09998C8.60605 3.09998 9.3 3.79393 9.3 4.64998C9.3 5.50604 8.60605 6.19998 7.75 6.19998C6.89434 6.19908 6.2009 5.50565 6.2 4.64998C6.2 3.79393 6.89395 3.09998 7.75 3.09998ZM3.1 20.6475C3.95605 20.6475 4.65 21.3414 4.65 22.1975C4.65 23.0535 3.95605 23.7475 3.1 23.7475C2.24395 23.7475 1.55 23.0535 1.55 22.1975C1.5509 21.3418 2.24434 20.6484 3.1 20.6475ZM5.16667 29.9667H1.03333V26.1537C1.03437 25.4064 1.63996 24.8009 2.38732 24.8H3.81268C4.55997 24.8009 5.16563 25.4064 5.16667 26.1537V29.9667ZM13.4333 26.1537V29.9667H9.3V26.1537C9.30103 25.4064 9.90663 24.8009 10.654 24.8H12.0793C12.8267 24.8009 13.4323 25.4064 13.4333 26.1537ZM11.3667 20.6475C12.2223 20.6484 12.9158 21.3418 12.9167 22.1975C12.9167 23.0535 12.2227 23.7475 11.3667 23.7475C10.5106 23.7475 9.81667 23.0535 9.81667 22.1975C9.81667 21.3414 10.5106 20.6475 11.3667 20.6475ZM15.5467 5.31648C15.4775 5.49396 15.3355 5.63326 15.1567 5.69895L10.0955 8.32465C9.9242 8.41351 9.81667 8.59041 9.81667 8.78332V20.144C8.84889 20.8596 8.51363 22.1547 9.01273 23.25H8.26667V14.4667H7.23333V23.25H5.45393C5.60092 22.9251 5.67836 22.5732 5.6814 22.2167H5.68333V9.29998C5.68327 9.01459 5.45187 8.78332 5.16654 8.78338C4.94095 8.78345 4.74145 8.92986 4.67377 9.14511L3.131 14.0544C3.0141 14.3768 2.65793 14.5434 2.33553 14.4265C2.31292 14.4183 2.29077 14.4088 2.2692 14.398C1.97115 14.244 1.84463 13.8844 1.98064 13.5776L3.35982 8.82368C3.73175 7.86849 4.64994 7.23777 5.675 7.23332H9.33333C9.41612 7.23345 9.49775 7.21349 9.57125 7.17532L14.7064 4.50977C15.0145 4.38125 15.3695 4.51274 15.5195 4.81099C15.599 4.96819 15.6089 5.1516 15.5467 5.31648Z"
                fill="#888C8E"
              />
              <path
                d="M21.4359 24.0423C22.4578 23.0467 22.4791 21.4111 21.4835 20.3892C20.4879 19.3673 18.8523 19.346 17.8304 20.3416C16.8085 21.3373 16.7872 22.9728 17.7828 23.9947C17.7985 24.0108 17.8144 24.0267 17.8305 24.0423C17.037 24.4478 16.5363 25.2626 16.5332 26.1537V30.4833C16.5331 30.7685 16.7643 30.9999 17.0496 31C17.0497 31 17.0498 31 17.0499 31H22.2165C22.5018 31 22.7331 30.7688 22.7332 30.4835C22.7332 30.4835 22.7332 30.4833 22.7332 30.4833V26.1537C22.7301 25.2626 22.2295 24.4478 21.4359 24.0423ZM19.6332 20.6474C20.4893 20.6474 21.1832 21.3414 21.1832 22.1974C21.1832 23.0535 20.4893 23.7474 19.6332 23.7474C18.7771 23.7474 18.0832 23.0535 18.0832 22.1974C18.0841 21.3418 18.7775 20.6484 19.6332 20.6474ZM21.6999 29.9666H17.5665V26.1537C17.5676 25.4064 18.1732 24.8009 18.9205 24.8H20.3459C21.0932 24.8009 21.6988 25.4064 21.6999 26.1537V29.9666Z"
                fill="#888C8E"
              />
              <path
                d="M29.7025 24.0423C30.7244 23.0467 30.7457 21.4111 29.7501 20.3892C28.7545 19.3673 27.1189 19.346 26.097 20.3416C25.0751 21.3373 25.0538 22.9728 26.0494 23.9947C26.0651 24.0108 26.081 24.0267 26.0971 24.0423C25.3036 24.4478 24.8029 25.2626 24.7998 26.1537V30.4833C24.7997 30.7685 25.0309 30.9999 25.3162 31C25.3163 31 25.3164 31 25.3165 31H30.4831C30.7684 31 30.9997 30.7688 30.9998 30.4835C30.9998 30.4835 30.9998 30.4833 30.9998 30.4833V26.1537C30.9967 25.2626 30.4961 24.4478 29.7025 24.0423ZM27.8998 20.6474C28.7559 20.6474 29.4498 21.3414 29.4498 22.1974C29.4498 23.0535 28.7559 23.7474 27.8998 23.7474C27.0438 23.7474 26.3498 23.0535 26.3498 22.1974C26.3507 21.3418 27.0441 20.6484 27.8998 20.6474ZM29.9665 29.9666H25.8331V26.1537C25.8342 25.4064 26.4398 24.8009 27.1871 24.8H28.6125C29.3598 24.8009 29.9654 25.4064 29.9665 26.1537V29.9666Z"
                fill="#888C8E"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect width="31" height="31" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </a>
        <transition name="chat-fade">
          <div
            class="conf-drawer"
            :class="{ portrait: bottom }"
            v-if="openConferences"
            @mouseenter="cancelCloseConf"
            @mouseleave="closeConf"
          >
            <div class="triangle-arrow"></div>
            <div class="conf-wrapper">
              <div
                class="single-conf-item"
                v-for="(item, i) in conferences"
                :key="i"
                @click="navigateTo('/live/' + item.loc_id)"
              >
                <svg
                  width="31"
                  height="31"
                  viewBox="0 0 31 31"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0)">
                    <path
                      d="M30.4836 1.35267e-08C30.4835 1.35267e-08 30.4834 1.35267e-08 30.4833 1.35267e-08H0.516667C0.231402 -6.45698e-05 6.45833e-05 0.231144 0 0.516408C0 0.516473 0 0.516602 0 0.516667V10.85H1.03333V1.03333H29.9667V12.4H11.8833V13.4333H30.4833C30.7686 13.4334 30.9999 13.2022 31 12.9169C31 12.9169 31 12.9167 31 12.9167V0.516667C31.0001 0.231402 30.7689 6.45969e-05 30.4836 1.35267e-08Z"
                      fill="#888C8E"
                    />
                    <path
                      d="M27.3831 2.58325H17.0498V3.61659H27.3831V2.58325Z"
                      fill="#888C8E"
                    />
                    <path
                      d="M28.9334 5.68335H18.6001V6.71668H28.9334V5.68335Z"
                      fill="#888C8E"
                    />
                    <path
                      d="M26.8665 8.78345H16.5332V9.81678H26.8665V8.78345Z"
                      fill="#888C8E"
                    />
                    <path
                      d="M16.4921 4.45455C16.1384 3.60431 15.1624 3.20183 14.3122 3.55555C14.2977 3.56163 14.2832 3.56783 14.2689 3.57428L10.0795 5.74751C10.2447 5.40509 10.3315 5.03012 10.3333 4.64998C10.3333 3.22327 9.17671 2.06665 7.75 2.06665C6.32329 2.06665 5.16667 3.22327 5.16667 4.64998C5.1686 5.21076 5.3548 5.75539 5.69657 6.19998H5.67507C4.20851 6.2098 2.89934 7.12152 2.38157 8.49373L1.00233 13.2476C0.673992 14.1005 1.09921 15.0582 1.95216 15.3865C2.34108 15.5362 2.77217 15.5337 3.15935 15.3794C3.6042 15.2002 3.95037 14.8383 4.1097 14.3859L4.65 12.6664V20.144C4.20541 19.8023 3.66078 19.6161 3.1 19.6141C1.67542 19.612 0.518798 20.7651 0.516667 22.1898C0.515633 22.8875 0.797217 23.5558 1.29729 24.0424C0.503685 24.4478 0.00310001 25.2626 1.35267e-08 26.1537V30.4833C-6.45698e-05 30.7686 0.231144 30.9999 0.516408 31C0.516473 31 0.516602 31 0.516667 31H5.68333C5.9686 31 6.19994 30.7688 6.2 30.4836C6.2 30.4835 6.2 30.4834 6.2 30.4833V26.1537C6.19748 25.4214 5.85726 24.7313 5.27801 24.2833H9.18872C8.60941 24.7313 8.26919 25.4214 8.26673 26.1537V30.4833C8.26667 30.7686 8.49787 30.9999 8.78314 31C8.7832 31 8.78333 31 8.7834 31H13.9501C14.2353 31 14.4667 30.7688 14.4667 30.4836C14.4667 30.4835 14.4667 30.4834 14.4667 30.4833V26.1537C14.4636 25.2626 13.963 24.4478 13.1694 24.0424C14.1895 23.0467 14.2094 21.4125 13.2137 20.3924C12.6005 19.7642 11.7101 19.4907 10.8501 19.6664V9.09713L15.5931 6.63437C16.4433 6.28071 16.8458 5.30473 16.4921 4.45455ZM7.75 3.09998C8.60605 3.09998 9.3 3.79393 9.3 4.64998C9.3 5.50604 8.60605 6.19998 7.75 6.19998C6.89434 6.19908 6.2009 5.50565 6.2 4.64998C6.2 3.79393 6.89395 3.09998 7.75 3.09998ZM3.1 20.6475C3.95605 20.6475 4.65 21.3414 4.65 22.1975C4.65 23.0535 3.95605 23.7475 3.1 23.7475C2.24395 23.7475 1.55 23.0535 1.55 22.1975C1.5509 21.3418 2.24434 20.6484 3.1 20.6475ZM5.16667 29.9667H1.03333V26.1537C1.03437 25.4064 1.63996 24.8009 2.38732 24.8H3.81268C4.55997 24.8009 5.16563 25.4064 5.16667 26.1537V29.9667ZM13.4333 26.1537V29.9667H9.3V26.1537C9.30103 25.4064 9.90663 24.8009 10.654 24.8H12.0793C12.8267 24.8009 13.4323 25.4064 13.4333 26.1537ZM11.3667 20.6475C12.2223 20.6484 12.9158 21.3418 12.9167 22.1975C12.9167 23.0535 12.2227 23.7475 11.3667 23.7475C10.5106 23.7475 9.81667 23.0535 9.81667 22.1975C9.81667 21.3414 10.5106 20.6475 11.3667 20.6475ZM15.5467 5.31648C15.4775 5.49396 15.3355 5.63326 15.1567 5.69895L10.0955 8.32465C9.9242 8.41351 9.81667 8.59041 9.81667 8.78332V20.144C8.84889 20.8596 8.51363 22.1547 9.01273 23.25H8.26667V14.4667H7.23333V23.25H5.45393C5.60092 22.9251 5.67836 22.5732 5.6814 22.2167H5.68333V9.29998C5.68327 9.01459 5.45187 8.78332 5.16654 8.78338C4.94095 8.78345 4.74145 8.92986 4.67377 9.14511L3.131 14.0544C3.0141 14.3768 2.65793 14.5434 2.33553 14.4265C2.31292 14.4183 2.29077 14.4088 2.2692 14.398C1.97115 14.244 1.84463 13.8844 1.98064 13.5776L3.35982 8.82368C3.73175 7.86849 4.64994 7.23777 5.675 7.23332H9.33333C9.41612 7.23345 9.49775 7.21349 9.57125 7.17532L14.7064 4.50977C15.0145 4.38125 15.3695 4.51274 15.5195 4.81099C15.599 4.96819 15.6089 5.1516 15.5467 5.31648Z"
                      fill="#888C8E"
                    />
                    <path
                      d="M21.4359 24.0423C22.4578 23.0467 22.4791 21.4111 21.4835 20.3892C20.4879 19.3673 18.8523 19.346 17.8304 20.3416C16.8085 21.3373 16.7872 22.9728 17.7828 23.9947C17.7985 24.0108 17.8144 24.0267 17.8305 24.0423C17.037 24.4478 16.5363 25.2626 16.5332 26.1537V30.4833C16.5331 30.7685 16.7643 30.9999 17.0496 31C17.0497 31 17.0498 31 17.0499 31H22.2165C22.5018 31 22.7331 30.7688 22.7332 30.4835C22.7332 30.4835 22.7332 30.4833 22.7332 30.4833V26.1537C22.7301 25.2626 22.2295 24.4478 21.4359 24.0423ZM19.6332 20.6474C20.4893 20.6474 21.1832 21.3414 21.1832 22.1974C21.1832 23.0535 20.4893 23.7474 19.6332 23.7474C18.7771 23.7474 18.0832 23.0535 18.0832 22.1974C18.0841 21.3418 18.7775 20.6484 19.6332 20.6474ZM21.6999 29.9666H17.5665V26.1537C17.5676 25.4064 18.1732 24.8009 18.9205 24.8H20.3459C21.0932 24.8009 21.6988 25.4064 21.6999 26.1537V29.9666Z"
                      fill="#888C8E"
                    />
                    <path
                      d="M29.7025 24.0423C30.7244 23.0467 30.7457 21.4111 29.7501 20.3892C28.7545 19.3673 27.1189 19.346 26.097 20.3416C25.0751 21.3373 25.0538 22.9728 26.0494 23.9947C26.0651 24.0108 26.081 24.0267 26.0971 24.0423C25.3036 24.4478 24.8029 25.2626 24.7998 26.1537V30.4833C24.7997 30.7685 25.0309 30.9999 25.3162 31C25.3163 31 25.3164 31 25.3165 31H30.4831C30.7684 31 30.9997 30.7688 30.9998 30.4835C30.9998 30.4835 30.9998 30.4833 30.9998 30.4833V26.1537C30.9967 25.2626 30.4961 24.4478 29.7025 24.0423ZM27.8998 20.6474C28.7559 20.6474 29.4498 21.3414 29.4498 22.1974C29.4498 23.0535 28.7559 23.7474 27.8998 23.7474C27.0438 23.7474 26.3498 23.0535 26.3498 22.1974C26.3507 21.3418 27.0441 20.6484 27.8998 20.6474ZM29.9665 29.9666H25.8331V26.1537C25.8342 25.4064 26.4398 24.8009 27.1871 24.8H28.6125C29.3598 24.8009 29.9654 25.4064 29.9665 26.1537V29.9666Z"
                      fill="#888C8E"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0">
                      <rect width="31" height="31" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <span>{{ item.name }}</span>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <div
      class="icon-wrap"
      v-if="showAgenda && !groupIcons && checkPermissions(['agenda_view'])"
      v-tooltip="$t('tooltips.agenda')"
    >
      <router-link to="/agenda">
        <svg
          width="34"
          height="34"
          viewBox="0 0 34 34"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.375 4.29846V2.25747C0.375 1.79502 0.757726 1.44764 1.22018 1.44764H7.72438V0.837271C7.72438 0.374818 8.0992 0 8.56165 0C9.0241 0 9.39892 0.374818 9.39892 0.837271V1.44764H22.4231V0.837271C22.4231 0.374818 22.798 0 23.2604 0C23.7229 0 24.0977 0.374818 24.0977 0.837271V1.44764H30.6349C31.0974 1.44764 31.4471 1.79502 31.4471 2.25747V4.29846C31.4471 4.76091 31.0722 5.13573 30.6098 5.13573C30.1473 5.13573 29.7725 4.76091 29.7725 4.29846V3.12218H24.0977V3.67729C24.0977 4.13975 23.7229 4.51457 23.2604 4.51457C22.798 4.51457 22.4231 4.13975 22.4231 3.67729V3.12218H9.39892V3.67729C9.39892 4.13975 9.0241 4.51457 8.56165 4.51457C8.0992 4.51457 7.72438 4.13975 7.72438 3.67729V3.12218H2.04954V4.29846C2.04954 4.76091 1.67472 5.13573 1.21227 5.13573C0.749818 5.13573 0.375 4.76091 0.375 4.29846ZM33.6254 26.4437C33.6254 30.6104 30.2354 34 26.0687 34C21.9019 34 18.5121 30.6095 18.5121 26.4428C18.5121 23.2058 20.5582 20.4363 23.4247 19.3621C23.316 19.2208 23.2513 19.0413 23.2513 18.8493C23.2513 18.3868 23.6261 18.007 24.0886 18.007H28.0489C28.5113 18.007 28.8861 18.3868 28.8861 18.8493C28.8861 19.0413 28.8215 19.2233 28.7127 19.3646C29.4091 19.6255 30.0571 19.9864 30.6391 20.4298L31.0526 20.0163C31.3796 19.6893 31.9098 19.6895 32.2367 20.0163C32.5637 20.3433 32.5636 20.8734 32.2367 21.2004L31.8519 21.585C32.9582 22.8997 33.6254 24.595 33.6254 26.4437ZM31.9508 26.444C31.9508 23.2006 29.3121 20.5618 26.0687 20.5618C22.8253 20.5618 20.1866 23.2005 20.1866 26.444C20.1866 29.6874 22.8253 32.3261 26.0687 32.3261C29.3121 32.326 31.9508 29.6874 31.9508 26.444ZM27.2016 24.3755L26.8886 24.6799V23.3848C26.8886 22.9223 26.5138 22.5475 26.0513 22.5475C25.5889 22.5475 25.214 22.9223 25.214 23.3848V26.7013C25.214 26.8153 25.2455 26.9239 25.2867 27.0228C25.3275 27.1213 25.3923 27.2134 25.4723 27.2934C25.5543 27.3753 25.6512 27.4368 25.7523 27.4776C25.7525 27.4777 25.7537 27.4777 25.7539 27.4778C25.7543 27.4779 25.7552 27.4571 25.7557 27.4573C25.844 27.4928 25.9402 27.4961 26.0404 27.4961C26.041 27.4961 26.0415 27.4961 26.0422 27.4961C26.051 27.4961 26.0599 27.4965 26.0688 27.4965C26.0777 27.4965 26.0865 27.4961 26.0953 27.4961C26.0959 27.4961 26.0965 27.4961 26.0971 27.4961C26.199 27.4961 26.2964 27.4921 26.3859 27.4554C26.486 27.4146 26.5797 27.364 26.6609 27.2828L28.3947 25.5543C28.7217 25.2273 28.7172 24.6998 28.3903 24.3728C28.0631 24.0458 27.5286 24.0485 27.2016 24.3755ZM18.2838 21.5422C18.2838 22.0046 17.9089 22.3794 17.4465 22.3794H16.7483V28.5322C16.7483 28.9947 16.3817 29.3664 15.9192 29.3664C15.891 29.3664 15.8714 29.3617 15.844 29.3591C15.8165 29.3618 15.7886 29.3568 15.7605 29.3568H1.22018C0.757726 29.3568 0.375 28.9947 0.375 28.5323V7.47674V7.47655C0.375 7.0141 0.757726 6.65733 1.22018 6.65733H30.6349C31.0974 6.65733 31.4471 7.0141 31.4471 7.47655V16.5552C31.4471 17.0176 31.0722 17.3924 30.6098 17.3924C30.1473 17.3924 29.7725 17.0176 29.7725 16.5552V15.3091H24.0977V15.3807C24.0977 15.8431 23.7229 16.2179 23.2604 16.2179C22.798 16.2179 22.4231 15.8431 22.4231 15.3807V15.3091H16.7483V20.7049H17.4465C17.9089 20.7049 18.2838 21.0797 18.2838 21.5422ZM7.72438 22.3794H2.04954V27.6821H7.72438V22.3794ZM7.72438 15.3091H2.04954V20.7049H7.72438V15.3091ZM15.0738 22.3794H9.39892V27.6821H15.0738V22.3794ZM15.0738 15.3091H9.39892V20.7049H15.0738V15.3091ZM16.7483 10.1615V13.6346H22.4231V10.1615C22.4231 9.69904 22.798 9.32422 23.2604 9.32422C23.7229 9.32422 24.0977 9.69904 24.0977 10.1615V13.6346H29.7725V8.33187H2.04954V13.6346H7.72438V10.1615C7.72438 9.69904 8.0992 9.32422 8.56165 9.32422C9.0241 9.32422 9.39892 9.69904 9.39892 10.1615V13.6346H15.0738V10.1615C15.0738 9.69904 15.4486 9.32422 15.911 9.32422C16.3735 9.32422 16.7483 9.69904 16.7483 10.1615Z"
            fill="#888C8E"
          />
        </svg>
      </router-link>
    </div>

    <div
      class="icon-wrap"
      v-tooltip="'List of Attendees'"
      v-if="parseInt(fairConfig.FC_LISTUSERS) && checkPermissions(['list_of_attendees_view'])"
    >
      <router-link to="/list-of-attendees">
        <svg
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="-46 -52.4 505.4 505.4"
          style="enable-background: new -46 -52.4 505.4 505.4; width: 33px"
          xml:space="preserve"
        >
          <g>
            <g>
              <path
                class="st0"
                d="M391.1,181.1c14.8-10.4,24.6-27.7,24.6-47.2c0-31.9-25.8-57.7-57.7-57.7s-57.7,25.8-57.7,57.7
                c0,19.5,9.7,36.8,24.6,47.2c-12.7,4.4-24.3,11.2-34.1,20c-13.5-11.5-29.4-20.3-46.8-25.5c21.1-12.8,35.3-36.1,35.3-62.6
                c0-40.4-32.7-73.1-73.1-73.1s-73.1,32.8-73.1,73.1c0,26.5,14.1,49.8,35.3,62.6c-17.2,5.2-32.9,13.9-46.3,25.2
                c-9.8-8.6-21.2-15.3-33.7-19.6c14.8-10.4,24.6-27.7,24.6-47.2c0-31.9-25.8-57.7-57.7-57.7S-2.4,102.1-2.4,134
                c0,19.5,9.7,36.8,24.6,47.2C-17.5,194.9-46,232.6-46,276.9v6.6c0,0.2,0.2,0.4,0.4,0.4H76.7c-0.7,5.5-1.1,11.2-1.1,16.9v6.8
                c0,29.4,23.8,53.2,53.2,53.2h155c29.4,0,53.2-23.8,53.2-53.2v-6.8c0-5.7-0.4-11.4-1.1-16.9H459c0.2,0,0.4-0.2,0.4-0.4v-6.6
                C459.2,232.5,430.8,194.8,391.1,181.1z M316.3,133.8c0-23,18.7-41.7,41.7-41.7s41.7,18.7,41.7,41.7c0,22.7-18.3,41.2-40.9,41.7
                c-0.3,0-0.5,0-0.8,0s-0.5,0-0.8,0C334.5,175.1,316.3,156.6,316.3,133.8z M148.9,113c0-31.5,25.6-57.1,57.1-57.1
                s57.1,25.6,57.1,57.1c0,30.4-23.9,55.3-53.8,57c-1.1,0-2.2,0-3.3,0s-2.2,0-3.3,0C172.8,168.3,148.9,143.4,148.9,113z M13.3,133.8
                c0-23,18.7-41.7,41.7-41.7s41.7,18.7,41.7,41.7c0,22.7-18.3,41.2-40.9,41.7c-0.3,0-0.5,0-0.8,0s-0.5,0-0.8,0
                C31.6,175.1,13.3,156.6,13.3,133.8z M79.5,267.8H-29.8c4.5-42.6,40.5-76,84.2-76.3c0.2,0,0.4,0,0.6,0s0.4,0,0.6,0
                c20.8,0.1,39.8,7.8,54.5,20.3C95.7,227.4,85,246.6,79.5,267.8z M320.8,307.6c0,20.5-16.7,37.2-37.2,37.2h-155
                c-20.5,0-37.2-16.7-37.2-37.2v-6.8c0-62.1,49.6-112.9,111.3-114.7c1.1,0.1,2.3,0.1,3.4,0.1s2.3,0,3.4-0.1
                c61.7,1.8,111.3,52.6,111.3,114.7V307.6z M332.7,267.8c-5.5-21.1-16-40-30.3-55.6c14.8-12.8,34-20.5,55-20.7c0.2,0,0.4,0,0.6,0
                s0.4,0,0.6,0c43.7,0.3,79.7,33.7,84.2,76.3H332.7z"
              />
            </g>
          </g>
        </svg>
      </router-link>
    </div>

    <div class="icon-wrap" v-if="groupIcons">
      <a @click="handleOpenBurger(!burgerOpen)">
        <svg
          width="29"
          height="24"
          viewBox="0 0 29 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="29" height="3.69231" fill="#888C8E" />
          <rect y="10.1538" width="29" height="3.69231" fill="#888C8E" />
          <rect y="20.3077" width="29" height="3.69231" fill="#888C8E" />
        </svg>
      </a>
      <transition name="chat-fade">
        <div
          class="floors-wrap"
          :class="{ portrait: bottom }"
          v-if="burgerOpen"
        >
          <div class="triangle" :class="{ portrait: bottom }"></div>
          <div class="floors" :class="{ portrait: bottom }">
            <a
              @click="handleChat"
              :class="{ 'router-link-exact-active': chatOpened }"
            >
              <svg
                width="34"
                height="26"
                viewBox="0 0 34 26"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M29.7031 0.547516H4.29693C1.92765 0.547516 0 2.47517 0 4.84445V21.1554C0 23.5247 1.92765 25.4523 4.29693 25.4523H29.7031C32.0723 25.4523 34 23.5247 34 21.1554V4.84445C34 2.47517 32.0723 0.547516 29.7031 0.547516ZM29.0318 3.31926L17 12.6136L4.96825 3.31926H29.0318ZM29.7031 22.6808H4.29693C3.45599 22.6808 2.77174 21.9965 2.77174 21.1556V5.12495L16.1528 15.4617C16.4022 15.6544 16.7012 15.7507 17 15.7507C17.2988 15.7507 17.5978 15.6544 17.8472 15.4617L31.2283 5.12495V21.1554C31.2283 21.9965 30.544 22.6808 29.7031 22.6808Z"
                />
              </svg>
            </a>
            <router-link to="/agenda" v-if="showAgenda">
              <svg
                width="34"
                height="34"
                viewBox="0 0 34 34"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.375 4.29846V2.25747C0.375 1.79502 0.757726 1.44764 1.22018 1.44764H7.72438V0.837271C7.72438 0.374818 8.0992 0 8.56165 0C9.0241 0 9.39892 0.374818 9.39892 0.837271V1.44764H22.4231V0.837271C22.4231 0.374818 22.798 0 23.2604 0C23.7229 0 24.0977 0.374818 24.0977 0.837271V1.44764H30.6349C31.0974 1.44764 31.4471 1.79502 31.4471 2.25747V4.29846C31.4471 4.76091 31.0722 5.13573 30.6098 5.13573C30.1473 5.13573 29.7725 4.76091 29.7725 4.29846V3.12218H24.0977V3.67729C24.0977 4.13975 23.7229 4.51457 23.2604 4.51457C22.798 4.51457 22.4231 4.13975 22.4231 3.67729V3.12218H9.39892V3.67729C9.39892 4.13975 9.0241 4.51457 8.56165 4.51457C8.0992 4.51457 7.72438 4.13975 7.72438 3.67729V3.12218H2.04954V4.29846C2.04954 4.76091 1.67472 5.13573 1.21227 5.13573C0.749818 5.13573 0.375 4.76091 0.375 4.29846ZM33.6254 26.4437C33.6254 30.6104 30.2354 34 26.0687 34C21.9019 34 18.5121 30.6095 18.5121 26.4428C18.5121 23.2058 20.5582 20.4363 23.4247 19.3621C23.316 19.2208 23.2513 19.0413 23.2513 18.8493C23.2513 18.3868 23.6261 18.007 24.0886 18.007H28.0489C28.5113 18.007 28.8861 18.3868 28.8861 18.8493C28.8861 19.0413 28.8215 19.2233 28.7127 19.3646C29.4091 19.6255 30.0571 19.9864 30.6391 20.4298L31.0526 20.0163C31.3796 19.6893 31.9098 19.6895 32.2367 20.0163C32.5637 20.3433 32.5636 20.8734 32.2367 21.2004L31.8519 21.585C32.9582 22.8997 33.6254 24.595 33.6254 26.4437ZM31.9508 26.444C31.9508 23.2006 29.3121 20.5618 26.0687 20.5618C22.8253 20.5618 20.1866 23.2005 20.1866 26.444C20.1866 29.6874 22.8253 32.3261 26.0687 32.3261C29.3121 32.326 31.9508 29.6874 31.9508 26.444ZM27.2016 24.3755L26.8886 24.6799V23.3848C26.8886 22.9223 26.5138 22.5475 26.0513 22.5475C25.5889 22.5475 25.214 22.9223 25.214 23.3848V26.7013C25.214 26.8153 25.2455 26.9239 25.2867 27.0228C25.3275 27.1213 25.3923 27.2134 25.4723 27.2934C25.5543 27.3753 25.6512 27.4368 25.7523 27.4776C25.7525 27.4777 25.7537 27.4777 25.7539 27.4778C25.7543 27.4779 25.7552 27.4571 25.7557 27.4573C25.844 27.4928 25.9402 27.4961 26.0404 27.4961C26.041 27.4961 26.0415 27.4961 26.0422 27.4961C26.051 27.4961 26.0599 27.4965 26.0688 27.4965C26.0777 27.4965 26.0865 27.4961 26.0953 27.4961C26.0959 27.4961 26.0965 27.4961 26.0971 27.4961C26.199 27.4961 26.2964 27.4921 26.3859 27.4554C26.486 27.4146 26.5797 27.364 26.6609 27.2828L28.3947 25.5543C28.7217 25.2273 28.7172 24.6998 28.3903 24.3728C28.0631 24.0458 27.5286 24.0485 27.2016 24.3755ZM18.2838 21.5422C18.2838 22.0046 17.9089 22.3794 17.4465 22.3794H16.7483V28.5322C16.7483 28.9947 16.3817 29.3664 15.9192 29.3664C15.891 29.3664 15.8714 29.3617 15.844 29.3591C15.8165 29.3618 15.7886 29.3568 15.7605 29.3568H1.22018C0.757726 29.3568 0.375 28.9947 0.375 28.5323V7.47674V7.47655C0.375 7.0141 0.757726 6.65733 1.22018 6.65733H30.6349C31.0974 6.65733 31.4471 7.0141 31.4471 7.47655V16.5552C31.4471 17.0176 31.0722 17.3924 30.6098 17.3924C30.1473 17.3924 29.7725 17.0176 29.7725 16.5552V15.3091H24.0977V15.3807C24.0977 15.8431 23.7229 16.2179 23.2604 16.2179C22.798 16.2179 22.4231 15.8431 22.4231 15.3807V15.3091H16.7483V20.7049H17.4465C17.9089 20.7049 18.2838 21.0797 18.2838 21.5422ZM7.72438 22.3794H2.04954V27.6821H7.72438V22.3794ZM7.72438 15.3091H2.04954V20.7049H7.72438V15.3091ZM15.0738 22.3794H9.39892V27.6821H15.0738V22.3794ZM15.0738 15.3091H9.39892V20.7049H15.0738V15.3091ZM16.7483 10.1615V13.6346H22.4231V10.1615C22.4231 9.69904 22.798 9.32422 23.2604 9.32422C23.7229 9.32422 24.0977 9.69904 24.0977 10.1615V13.6346H29.7725V8.33187H2.04954V13.6346H7.72438V10.1615C7.72438 9.69904 8.0992 9.32422 8.56165 9.32422C9.0241 9.32422 9.39892 9.69904 9.39892 10.1615V13.6346H15.0738V10.1615C15.0738 9.69904 15.4486 9.32422 15.911 9.32422C16.3735 9.32422 16.7483 9.69904 16.7483 10.1615Z"
                  fill="#888C8E"
                />
              </svg>
            </router-link>
            <a
              :href="item.smi_link"
              v-tooltip="item.smi_name"
              v-for="(item, i) in additionalElements"
              :key="i"
              class="additional-links"
            >
              <img :src="item.smi_image" alt="link-image" />
            </a>
          </div>
        </div>
      </transition>
    </div>

    <div
      class="icon-wrap"
      v-else
      v-for="(item, i) in additionalElements"
      :key="i"
      
    >
      <a
        :href="item.smi_link"
        target="_blank"
        v-tooltip="item.smi_name"
        class="additional-links"
      >
        <img :src="item.smi_image" alt="link-image" />
      </a>
    </div>
  </div>
</template>

<script>
import api from "../../api";
import axios from "axios";
import { mapState } from "vuex";
export default {
  props: {
    mobile: Boolean,
    bottom: {
      type: Boolean,
      default: false,
    },
    groupIcons: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showAgenda: true,
      openConferences: false,
      openFloors: false,
      confTimer: null,
      floorTimer: null,
      conferences: [],
      burgerOpen: false,
      floors: [],
      additionalElements: [],
    };
  },
  mounted() {
    this.init();
  },
  computed: {
    ...mapState(["chatOpened", "fairConfig"]),
  },
  methods: {
    sid() {
      return localStorage.getItem("sid");
    },
    async getItemImageUrl(item) {
      let img = await axios.get(
        process.env.VUE_APP_API_URL +
          `/sidemenuitems/${item.smi_id}?sid=${this.sid()}`
      );
      return img.data;
    },
    async getAdditionalItemsForSidebar() {
      try {
        let res = await api.getSideBarItems();
        for (const item of res.data.res) {
          item.smi_image = await this.getItemImageUrl(item);
          this.additionalElements.push(item);
        }
      } catch (error) {
        // this.handleError(error)
      }
    },
    async getFloors() {
      let res = await api.getFloorsElements();
      this.floors = res.data.res.map((el) => {
        let obj = {
          name: el.loc_name,
          loc_id: el.loc_id,
        };
        return obj;
      });
    },
    async init() {
      this.checkAgenda();
      this.getAdditionalItemsForSidebar();
      this.getFloors();
      let res = await api.getConferencesElements();
      let confs = res.data.res;

      for (const conf of confs) {
        for (const index in conf) {
          if (
            conf[index].type === "screen" &&
            conf[index].ltp_code === "conf"
          ) {
            // console.log("type screen found", conf[index])
            let obj = {
              index: index,
              name: conf[index].loc_name,
              loc_id: conf[index].loc_id,
            };
            this.conferences.push(obj);
          }
        }
      }
    },
    async checkAgenda() {
      let res = await api.getAgendas();
      if (!res.data.data) {
        this.showAgenda = false;
      } else {
        this.showAgenda = true;
      }
    },
    navigateTo(link) {
      setTimeout(() => {
        if (this.$route.path !== link) this.$router.push(link);
      }, 100);
    },
    openConf() {
      if (this.mobile) return;
      setTimeout(() => {
        this.cancelCloseConf();
        this.openConferences = true;
      }, 0);
    },
    cancelCloseConf() {
      if (this.mobile) return;
      if (this.confTimer) {
        clearTimeout(this.confTimer);
        this.confTimer = null;
      }
    },
    closeConf() {
      if (this.mobile) return;
      this.cancelCloseConf();
      this.confTimer = setTimeout(() => {
        this.openConferences = false;
      }, 500);
    },
    toggleConf() {
      if (!this.mobile) return;
      this.openConferences = !this.openConferences;
    },
    openFloor() {
      if (this.mobile) return;
      setTimeout(() => {
        this.cancelCloseFloor();
        this.openFloors = true;
      }, 0);
    },
    cancelCloseFloor() {
      if (this.mobile) return;
      if (this.floorTimer) {
        clearTimeout(this.floorTimer);
        this.floorTimer = null;
      }
    },
    closeFloor() {
      if (this.mobile) return;
      this.cancelCloseFloor();
      this.floorTimer = setTimeout(() => {
        this.openFloors = false;
      }, 500);
    },
    toggleFloor() {
      if (!this.mobile) return;
      this.openFloors = !this.openFloors;
    },
    handleOpen(val) {
      for (let key of Object.keys(val)) {
        this.openFloors[key] = val[key];
      }
    },
    handleChat() {
      this.$emit("handle-chat");
    },
    handleOpenBurger(val) {
      this.burgerOpen = val;
    },
  },
};
</script>

<style scoped lang="scss">
.side-bar-wrap {
  width: var(--nav-height);
  background: var(--main-color-highlight);
  box-shadow: 0px 4px 80px rgba(0, 0, 0, 0.25);
  z-index: 15;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: calc(var(--nav-height)) 0 3% 0;
  box-sizing: border-box;
  user-select: none;
  position: fixed;
  bottom: 0;
  top: 0;
  left: 0;
  right: unset;
  &.portrait {
    height: var(--nav-height);
    width: unset;
    flex-direction: row;
    padding: 0 10px;
    bottom: 0;
    left: 0;
    right: 0;
    top: unset;
    padding: 0 3%;
  }
  &.space {
    justify-content: space-between;
  }
}
.icon-wrap {
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative;
  user-select: none;
}
.conf-drawer {
  cursor: default;
  position: absolute;
  &.portrait {
    top: unset;
    bottom: 0;
    left: 0;
    min-height: 200px;
    min-width: unset;
    width: 60px;
    .triangle-arrow {
      position: absolute;
      left: 0;
      bottom: 58px;
      display: inline-block;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 30px 30px 0 30px;
      border-color: var(--main-color-highlight) transparent transparent
        transparent;
    }
    .conf-wrapper {
      flex-direction: column-reverse;
      margin-left: 0;
      bottom: 88px;
      position: absolute;
      width: 100%;
      height: unset;
      background: var(--main-color-highlight);
      // border-radius: 5px;
      border-top-right-radius: 5px;
      border-top-left-radius: 5px;
      border-bottom-right-radius: 0px;
      .single-conf-item {
        margin: 12px auto;
      }
    }
  }
  top: 0;
  left: 0;
  height: 60px;
  min-width: 200px;
  .triangle-arrow {
    position: absolute;
    left: 60px;
    display: inline-block;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 30px 40px 30px 0;
    border-color: transparent var(--main-color-highlight) transparent
      transparent;
  }
  .conf-wrapper {
    display: flex;
    margin-left: 100px;
    background: var(--main-color-highlight);
    // border-radius: 5px;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    width: auto;
    height: 60px;
    .single-conf-item {
      cursor: pointer;
      min-width: 50px;
      padding: 0;
      margin: auto 12px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      span {
        font-size: 13px;
      }
    }
  }
}
a {
  border-radius: 18px;
  padding: 10px;
  display: flex;
  align-items: center;
  transition: background-color 0.2s ease;
}
path {
  transition: fill 0.2s ease;
  fill: #888c8e;
}
.router-link-exact-active {
  background: var(--main-color-shade);
  border-radius: 18px;
  color: var(--main-color);
  path {
    fill: var(--main-color);
  }
}
.floors-wrap {
  display: flex;
  position: absolute;
  align-items: center;
  left: 100%;
  padding-left: 20px;
  box-sizing: border-box;
  user-select: none;
  flex-direction: row;
  &.portrait {
    left: unset;
    bottom: 100%;
    padding-left: 0;
    padding-bottom: 20px;
    flex-direction: column-reverse;
  }
}
.floors {
  display: flex;
  max-height: 100%;
  flex-wrap: nowrap;
  align-items: center;
  background: var(--main-color-highlight);
  border-radius: 0 6px 6px 0;
  user-select: none;
  &.portrait {
    flex-direction: column;
    border-radius: 6px 6px 0 0;
  }
  label {
    font-size: 0.5rem;
    display: block;
    white-space: nowrap;
  }
  a {
    display: block;
    padding: 6px;
    margin: 0 5px;
    svg {
      min-height: 34px;
      min-width: 34px;
    }
  }
  .router-link-exact-active {
    path {
      fill: var(--main-color);
    }
  }
  .additional-links {
    img {
      width: 34px;
      height: 34px;
    }
  }
}
.triangle {
  width: 0;
  height: 0;
  border-top: 27px solid transparent;
  border-bottom: 27px solid transparent;
  border-right: 25px solid var(--main-color-highlight);
  &.portrait {
    border-bottom: unset;
    border-left: 27px solid transparent;
    border-right: 27px solid transparent;
    border-top: 25px solid var(--main-color-highlight);
  }
}
</style>
